import React, { forwardRef, useEffect, useRef } from 'react';
import {
    channelOptionsMenuWrapper,
    channelOptionsMenuContainer,
    channelOptionsMenuItemButton,
    channelOptionsMenuItemIcon,
    channelOptionsMenuItemLabel
} from '../../styles/commonStyles';

const CommonMenu = forwardRef(({ containerClassName, items, onClose, className }, ref) => {
    const internalRef = useRef(null);
    const menuRef = ref || internalRef;
    const containerClasses = containerClassName || channelOptionsMenuContainer;

    useEffect(() => {
        if (!onClose) return;
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose, menuRef]);

    return (
        <div ref={menuRef} className={`${channelOptionsMenuWrapper} ${className || ''}`}>
            <div className={containerClasses}>
                {items.map(({ id, label, icon, className, onClick, isCustom, customContent }) => {
                    if (isCustom && customContent) {
                        return <div key={id}>{customContent}</div>;
                    }
                    
                    return (
                        <button
                            key={id}
                            onClick={onClick}
                            className={`${channelOptionsMenuItemButton} ${className || ''} flex items-center w-full`}
                        >
                            {icon && <span className={channelOptionsMenuItemIcon}>{icon}</span>}
                            <span className={`${channelOptionsMenuItemLabel} flex-1`}>{label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
});

export default CommonMenu;
